/**
 * Date utility functions for job date management
 */

/**
 * Format date from ISO string to DD/MM/YYYY
 */
export const formatDateDisplay = (dateStr: string | null | undefined): string => {
  if (!dateStr) return 'Not set'
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return 'Not set'
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

/**
 * Format date and time from ISO string to DD/MM/YYYY, HH:MM
 */
export const formatDateTimeDisplay = (dateStr: string | null | undefined): string => {
  if (!dateStr) return 'Not set'
  const date = new Date(dateStr)
  if (isNaN(date.getTime())) return 'Not set'
  const day = String(date.getDate()).padStart(2, '0')
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const year = date.getFullYear()
  const hours = String(date.getHours()).padStart(2, '0')
  const minutes = String(date.getMinutes()).padStart(2, '0')
  return `${day}/${month}/${year}, ${hours}:${minutes}`
}

/**
 * Format date from Date object to YYYY-MM-DD for Supabase (DATE type)
 */
export const formatDateForDb = (date: Date | null): string | null => {
  if (!date) return null
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

/**
 * Format date and time from Date object to ISO string for Supabase (TIMESTAMPTZ type)
 */
export const formatDateTimeForDb = (date: Date | null): string | null => {
  if (!date) return null
  return date.toISOString()
}

/**
 * Parse DD/MM/YYYY to Date
 */
export const parseDateFromDisplay = (dateStr: string): Date | null => {
  if (!dateStr || dateStr === 'Not set' || dateStr === 'N/A') return null
  const parts = dateStr.split('/')
  if (parts.length === 3) {
    return new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]))
  }
  return null
}

/**
 * Parse ISO string to Date
 */
export const parseDateFromISO = (dateStr: string | null | undefined): Date | null => {
  if (!dateStr) return null
  const date = new Date(dateStr)
  return isNaN(date.getTime()) ? null : date
}

/**
 * Add days to a date
 */
export const addDays = (date: Date, days: number): Date => {
  const result = new Date(date)
  result.setDate(result.getDate() + days)
  return result
}

/**
 * Check if date is in the past
 */
export const isDateInPast = (date: Date | null): boolean => {
  if (!date) return false
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const compareDate = new Date(date)
  compareDate.setHours(0, 0, 0, 0)
  return compareDate < today
}

/**
 * Get today's date
 */
export const getToday = (): Date => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  return today
}


